<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-11 15:31:05
 * @FilePath: \gcp-fe\src\app\procurementNotice\views\procurementNotice.vue
 * @Description: 采购公告
-->
<template>
  <div>
    <div class="wrapper">
      <div v-if="isShowBread" style="padding-top: 10px;">
        <base-bread-crumb
          :currBreadCrumb="currBreadCrumb"
          :isShowPortal="false"
        ></base-bread-crumb>
      </div>
      <div class="navBox">
        <div
          v-for="(item, index) in dataJs.tabList"
          :key="index"
          class="navBoxItem"
          :class="{ active: index == active }"
          @click="handleNav(item)"
        >
          <img :src="item.img" alt="" srcset="" />
          <span :title="item.title">{{ item.title }}</span>
        </div>
        <div class="navBoxItem navBoxItems">
          <img src="@/basa/assets/images/gg6.png" alt="" srcset="" />
          <span :title="$t('page.content.engineeringServiceInProgress')">{{
            $t("page.content.engineeringServiceInProgress")
          }}</span>
        </div>
      </div>
      <div
        class="contentBox"
        v-if="active !== 5 && active !== 6 && active !== 7"
        key="formSearch"
      >
        <formSearch :active="active"></formSearch>
      </div>
      <div class="contentBox" v-else-if="active == 5" key="lianhe">
        <div class="ccui-clearfix wrapper">
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewLianhe(1, 2)"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="ccui-multifunctional-table-wrapper mt20">
          <el-table
            :data="lianheData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.xunjiaName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleViewLianhe(row, 1)" class="a-line">{{
                  row.purchaseName
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.type }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseTypeName"
              :label="$t('page.content.xunjiaType')"
            >
              <!-- // row.purchaseTypeName == `${$t("page.content.labelMenu11")}` -->
              <!-- $t("page.content.labelMenu10") -->
              <template slot-scope="{ row }"
                ><span :title="row.purchaseName">{{
                  row.schemePurchaseType == "1"
                    ? $t("page.content.labelMenu13")
                    : row.schemePurchaseType == "7"
                    ? $t("page.content.labelMenu10")
                    : ""
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.publishedTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.xunjiajiezhiTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.purchaseEndTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="contentBox" v-else-if="active == 6" key="overseas">
        <div class="ccui-clearfix wrapper">
          <el-link
            :underline="false"
            type="info"
            class="fr view-all"
            style="transform: translateY(20px);"
            @click="handleViewOverseas(1, 2)"
            >{{ $t("page.content.MoreAndMore") }} ></el-link
          >
        </div>
        <div class="ccui-multifunctional-table-wrapper mt20">
          <el-table
            :data="overseasData"
            header-cell-class-name="table_header"
            :border="false"
            :row-style="{ height: 0 }"
            style="width: 100%; margin-top: 20px"
            :empty-text="$t('page.content.noData')"
          >
            <el-table-column
              prop="noticeTitle"
              :label="$t('page.content.noticeName')"
              width="350"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }">
                <a @click="handleViewOverseas(row, 1)" class="a-line">{{
                  row.purchaseName
                }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="bigClassName"
              :label="$t('page.content.category')"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="{ row }"
                ><span>{{ row.type }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="purchaseType"
              :label="$t('page.content.purchaseType')"
            >
              <!-- // row.purchaseTypeName == `${$t("page.content.labelMenu11")}` -->
              <template slot-scope="{ row }"
                ><span :title="row.purchaseType">{{
                  row.purchaseType
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.publishTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.publishedTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
            <el-table-column
              prop="packAmt"
              :label="$t('page.content.deadlineEndTime')"
            >
              <template slot-scope="{ row }"
                ><span>{{
                  moment(row.purchaseEndTime).format("YYYY-MM-DD HH:mm")
                }}</span></template
              >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import moment from "moment";
import createDataJs from "../js";
import formSearch from "../components/formSearch.vue";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { qryJointProNotice, OAuth } from "@/app/procurementNotice/api/shopping";

export default {
  components: {
    baseBreadCrumb,

    formSearch
  },
  data() {
    return {
      moment,
      supInfo: this.$store.state.user.supInfo || {},
      pageTotal: 1,
      lianheData: [], // 联合采购专区公告
      overseasData: [], // 海外采购专区公告
      dataJs: createDataJs(),
      active: 0,
      currBreadCrumb: [],
      isShowBread: false
    };
  },
  created() {
    this.currBreadCrumb = [
      {
        title: this.$t("page.content.procurementAnnouncement"),
        path: "/procurementNotice"
      },
      {
        title: this.$t("page.content.openProcurementAnnouncement"),
        path: "/procurementNotice"
      },
      { title: sessionStorage.getItem("searchName") }
    ];
  },
  watch: {},
  mounted() {
    if (this.$route.query.type == 4) {
      this.currBreadCrumb[1].title = this.$t(
        "page.content.biddingResultPublicity"
      );
      this.currBreadCrumb[1].path = "/procurementNotice?type=4";
    }
  },
  activated() {},
  deactivated() {},
  methods: {
    handleNav(row) {
      this.active = row.key - 1;
      console.log(this.active, "===010203");
      if (this.active == 5) {
        this.getXunjiaList();
      }
      if (this.active == 6) {
        // 海外采购专区公告
        this.getOverseasList();
      }
      if (this.active == 7) {
        this.$message({
          message: this.$t("page.content.underConstruction"),
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return (this.active = 0);
      }
    },
    handleViewLianhe(row, type) {
      if (Cookies.get("access_token")) {
        this.lianheGo(row, type);
      } else {
        this.$message({
          showClose: true,
          message: "请先登录！",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
      }
    },
    // 海外采购专区公告 start
    handleViewOverseas(row, type) {
      if (Cookies.get("access_token")) {
        this.overseasGo(row, type);
      } else {
        this.$message({
          showClose: true,
          message: "请先登录！",
          duration: 3000,
          type: "error",
          ccuiCustom: true
        });
      }
    },
    getXunjiaList(obj) {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      // return new Promise(resolve => {
      let params = {
        noticeStatusEndFlag: "1",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        supCodeList: supCodeList,
        noticeType: this.noticeType,
        isShowPageLoading: true
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      if (Cookies.get("sup_code")) {
        params.data = {
          supCode: Cookies.get("sup_code")
        };
      }
      Object.assign(params, obj);
      qryJointProNotice(params).then(res => {
        if (res.data.code === "0") {
          this.pageTotal = res.data.data.recordsTotal;
          this.lianheData = res.data.data;
        }
      });
    },
    getOverseasList(obj) {
      // let supCodeList = [];
      // if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
      //   supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
      //     return item.supCode;
      //   });
      // }
      // return new Promise(resolve => {
      let params = {
        data: {
          sourceSystemCode: "3"
        },
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        // supCodeList: supCodeList,
        // noticeType: this.noticeType,
        isShowPageLoading: true
      };
      // if (
      //   Cookies.get("language") !== undefined &&
      //   Cookies.get("language") !== "zh-cn"
      // ) {
      //   params.overseasSupFlag = 1;
      // }
      Object.assign(params, obj);
      qryJointProNotice(params).then(res => {
        if (res.data.code === "0") {
          this.pageTotal = res.data.data.recordsTotal;
          this.overseasData = res.data.data;
        }
      });
    },
    lianheGo(row, type) {
      //type详情1 更多2
      let oma_remote_url =
          "https://liancai.iccec.cn/account/supplier@corpid@10000",
        redirect =
          "https://liancai.iccec.cn/mall/inquiryDetail?planNo=" +
          row.noticeCode;
      if (type == 2) {
        redirect = "https://liancai.iccec.cn/mall/purchase?";
      }
      let code = "";
      if (window.location.host.indexOf("test01") != -1) {
        oma_remote_url = "http://lczq.bmmyou.com/account/supplier@corpid@10000";
        redirect =
          "http://lczq.bmmyou.com/mall/inquiryDetail?planNo=" + row.noticeCode;
        if (type == 2) {
          redirect = "http://lczq.bmmyou.com?";
        }
      }
      OAuth({
        isShowLoading: true,
        // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
        oma_remote_url: oma_remote_url,
        liancai: true
      })
        .then(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
            return;
          }
          let query = res.data.data.split("?")[1];
          let pairs = query.split("&");
          for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf("=");
            if (pos == -1) continue;
            var argname = pairs[i].substring(0, pos),
              value = pairs[i].substring(pos + 1);
            value = decodeURIComponent(value);

            if ("code" == argname) {
              code = value;
            }
          }
          console.log(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code
          );
          window.open(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code,
            "_blank"
          );
        })
        .catch(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
          }
        });
    },
    overseasGo(row, type) {
      //type详情1 更多2
      let oma_remote_url = "https://hwsp.iccec.cn/@corpid@10000",
        redirect = "https://hwsp.iccec.cn/";
      let code = "";
      if (
        window.location.host.indexOf("test01") != -1 ||
        window.location.host.indexOf("uat01") != -1
      ) {
        oma_remote_url = "https://uat01-hwsp.iccec.cn/@corpid@10000";
        redirect = "https://uat01-hwsp.iccec.cn/";
      }
      OAuth({
        isShowLoading: true,
        // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
        oma_remote_url: oma_remote_url
        // liancai: true
      })
        .then(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
            return;
          }
          let query = res.data.data.split("?")[1];
          let pairs = query.split("&");
          for (var i = 0; i < pairs.length; i++) {
            var pos = pairs[i].indexOf("=");
            if (pos == -1) continue;
            var argname = pairs[i].substring(0, pos),
              value = pairs[i].substring(pos + 1);
            value = decodeURIComponent(value);

            if ("code" == argname) {
              code = value;
            }
          }
          console.log(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code
          );
          window.open(
            res.data.data.split("?")[0] +
              "?supinfoId=" +
              sessionStorage.getItem("supCodeUrl") +
              "&redirect=" +
              encodeURIComponent(redirect) +
              "&code=" +
              code,
            "_blank"
          );
        })
        .catch(res => {
          if (res.data.code == 111) {
            this.$message({
              showClose: true,
              message: "请先登录！",
              duration: 3000,
              type: "error",
              ccuiCustom: true
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.navBox {
  margin-top: 20px;
  background-color: #fff;
  height: 56px;
  line-height: 56px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  .navBoxItem {
    display: flex;
    align-items: center;
    cursor: pointer;

    span {
      display: inline-block;
      margin-left: 5px;
      white-space: nowrap !important;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 130px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #4a4a4a;
    }
  }

  .navBoxItems {
    cursor: default;
  }

  .active {
    span {
      color: #4393ff;
    }

    border-bottom: 5px solid #4393ff;
  }
}
.a-line {
  color: #4393ff;
}
</style>
